import React from 'react';
import Sidebar from '../../../sideBar';
import AssignmentHistory from './assignmentHistory';

const TaskDetails = ({ changeActiveCourse }) => {
	return (
		<section className="step-container align-stretch container">
			<Sidebar />
			<div className="page-right-section">
				<div className="dashboard-page" style={{ marginTop: '0px' }}>
					<div className="db-body">
						<div className="settingsContainer">
							<div id="taskListContainer">
								<div className="panel panel-default panel-body coach-table">
									<div className="page-header-product-left ">
										<a target="_self" href="mycourse">
											<i className="fa fa-repeat"></i> Go back
										</a>
									</div>
									<AssignmentHistory />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};
export default TaskDetails;
